/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Author:    leo<zhudongxian@frippler.com>
  | @Title:     费用中心-订单发票管理 API 接口
  | @Version:   2018-12-25  [A] 新建文件
  +--------------------------------------------------------------------------------------
*/
import request from '@/utils/request'
const generalApiHost = process.env.VUE_APP_GENERAL_API_HOST;

export function getOrderInvoiceListApi(query) {
  return request({
    url: generalApiHost + '/expense/oinvoice/list',
    method: 'get',
    params: query
  })
}

export function getOrderInvoiceDetailApi(oinvoiceid) {
  return request({
    url: generalApiHost + '/expense/oinvoice/get',
    method: 'get',
    params: { oinvoiceid }
  })
}

export function getUninvoicedOrderListApi() {
  return request({
    url: generalApiHost +  '/expense/oinvoice/query',
    method: 'get'
  })
}

export function applyOrderInvoiceApi(formData) {
  return request({
    url: generalApiHost + '/expense/oinvoice/apply',
    method: 'post',
    data: formData
  })
}
